"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCW = function FlagCW(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "184.61",
    width: "409.6",
    height: "35.31",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-97.84-55.93l-7,20.83-22,.17A2.19,2.19,0,0,0-128-31l17.66,13.05L-117,3a2.19,2.19,0,0,0,3.36,2.44L-95.77-7.32-77.9,5.44A2.19,2.19,0,0,0-74.54,3l-6.62-20.93L-63.5-31a2.19,2.19,0,0,0-1.29-3.95l-21.95-.17-7-20.83a2.19,2.19,0,0,0-4.15,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-147.89-94.36l-4,12-12.7.1a1.27,1.27,0,0,0-.75,2.29l10.23,7.55L-159-60.25A1.26,1.26,0,0,0-157-58.84l10.34-7.39,10.34,7.39a1.26,1.26,0,0,0,1.94-1.41l-3.83-12.12L-128-79.92a1.27,1.27,0,0,0-.74-2.29l-12.71-.1-4-12a1.27,1.27,0,0,0-2.41,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCW;
exports["default"] = _default;